import React from "./Slider.css"
import Slider from 'infinite-react-carousel';
import HomeContainer from "../HomeContainer/HomeContainer"
import {categories} from "../../data.js"

const Slide = () => {


  return (
   <div className="slider" id="home">
    <Slider  autoplay autoplaySpeed={7000} autoplayScroll={1} arrows={false} duration={500}>
      {categories.map((item) => (
        <HomeContainer key={item.id} item={item}/>
      ))}
    </Slider>

   </div>
  )
}

export default Slide